import { ZOOM_DEFAULT_VALUE, type IZoomService } from './zoom-service';
import { AngularInjector } from '../system';

export function getCurrentZoomValue() {
    try {
        const zoomService = AngularInjector.get<IZoomService>('zoomService');
        return zoomService.getValue();
    } catch {
        return ZOOM_DEFAULT_VALUE;
    }
}
